import { useState } from 'react';
import type {
  CustomDateRange,
  TimeRange,
} from '../../components/dialogs/TimeRangeSelector';
import type { Machine } from '../../gql/generated';
import { isMachineRunning } from './machineSimulation';
import { SortingCharts, SortingNotice, SortingTabFrame } from './SortingCharts';
import { useMachineSortingView } from './useMachineSortingView';

/** The Sorting tab on the machine's own stream and criteria counts. */
export function MachineSortingDataTab({ machine }: { machine: Machine }) {
  const [timeRange, setTimeRange] = useState<TimeRange>('24h');
  const [customRange, setCustomRange] = useState<CustomDateRange>();
  const { view, loading, error, live } = useMachineSortingView(
    machine,
    timeRange,
    customRange,
    isMachineRunning(machine)
  );

  return (
    <SortingTabFrame
      timeRange={timeRange}
      customRange={customRange}
      onRangeChange={setTimeRange}
      onCustomRangeChange={setCustomRange}
      live={live && view !== null}
    >
      {view ? (
        <SortingCharts view={view} />
      ) : loading ? (
        <SortingNotice>Loading sorting figures…</SortingNotice>
      ) : error ? (
        <SortingNotice>Sorting figures could not be loaded.</SortingNotice>
      ) : (
        <SortingNotice>No sorting in this period.</SortingNotice>
      )}
    </SortingTabFrame>
  );
}
